import React from 'react';
import { Trophy, Wheat } from 'lucide-react';
export function QualityBadges() {
  return <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 w-full animate-fade-in-up" data-id="element-189">
      {/* Badge 1: Rectangular Rank Style */}
      <div className="group flex items-center gap-3 px-4 py-2 bg-white border border-slate-200 rounded-lg shadow-sm hover:shadow-md hover:border-indigo-200 transition-all duration-300" data-id="element-190">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-amber-100 text-amber-600 group-hover:scale-110 transition-transform duration-300" data-id="element-191">
          <Trophy className="w-5 h-5 fill-current" data-id="element-192" />
        </div>
        <div className="flex flex-col items-start" data-id="element-193">
          <span className="text-[10px] uppercase tracking-wider font-semibold text-slate-500" data-id="element-194">
            Market Leader
          </span>
          <span className="text-sm font-bold text-slate-900" data-id="element-195">
            #1 Performance Platform
          </span>
        </div>
      </div>

      {/* Badge 2: Laurel Wreath Style */}
      <div className="group flex items-center px-5 py-2 bg-white/50 backdrop-blur-sm border border-slate-200/60 rounded-full shadow-sm hover:shadow-md hover:bg-white transition-all duration-300" data-id="element-196">
        <Wheat className="w-8 h-8 text-indigo-600 -scale-x-100 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-197" />
        <div className="flex flex-col items-center px-2" data-id="element-198">
          <span className="text-[10px] uppercase tracking-wider font-semibold text-indigo-600" data-id="element-199">
            Top Rated
          </span>
          <span className="text-lg font-bold text-slate-900 leading-none" data-id="element-200">
            2025-2026
          </span>
        </div>
        <Wheat className="w-8 h-8 text-indigo-600 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-201" />
      </div>
    </div>;
}